export default __webpack_public_path__ + "static/media/IMG_9498.8e799d2f.jpeg";